'use strict';

var angular = require('angular');
var _ = require('lodash');
var gridColumns = require('../config/bookings-intake-modal-grid-columns.json');
var gridColumnsLY = require('../config/bookings-intake-modal-grid-last-year-columns.json');
var gridColumnsRY = require('../config/bookings-intake-modal-grid-reference-year-columns.json');
var BookingsIntakeModalController = function BookingsIntakeModalController($scope, $filter, constants, featureToggleService, dataProviderService, bookingsIntakeFieldUtils) {
  var MAX_ROWS = 5;
  var MAPPED_MODE = featureToggleService.isEnabled('MAPPED_MODE');
  function mapGridToFields(gridId) {
    switch (gridId) {
      case 'segment-flight-analysis':
      case 'flight-summary':
        return {
          current: 'currentBookings',
          lastYear: 'lastYearCurrentBookings'
        };
      case 'cabin-flight-analysis':
        return {
          current: 'resHoldTotal',
          lastYear: 'lastYearCurrentBookings',
          referenceYear: 'referenceYearCurrentBookings'
        };
      case 'service-flight-analysis':
      case 'service-demand-analysis':
        return {
          current: MAPPED_MODE ? 'regularReservationHoldingsTotal' : 'mappedReservationHoldingsTotal',
          lastYear: MAPPED_MODE ? 'regularLastYearCurrentBookings' : 'mappedLastYearCurrentBookings'
        };
      case 'market-demand-analysis':
      case 'market-product-group-analysis':
        return {
          current: MAPPED_MODE ? 'bookingsTotal' : 'bookingsMappedTotal',
          lastYear: MAPPED_MODE ? 'regularLastYearCurrentBookings' : 'mappedLastYearCurrentBookings'
        };
      case 'class-flight-analysis':
      case 'inventory-management':
        return {
          current: 'segClassCurrentBookings',
          lastYear: 'segClassLastYearCurrentBookings'
        };
      case 'service-management':
        return {
          current: MAPPED_MODE ? 'bookings' : 'mappedBookings',
          lastYear: MAPPED_MODE ? 'lastYearBookings' : 'lastYearMappedBookings'
        };
      default:
        return {};
    }
  }
  function updateHeader(dtd, bookings) {
    var title = 'Curr DTD ' + dtd + '<span class="grid-title-2n-part"> Curr Bkgs ' + bookings + '</span>';
    if ($scope.modalMode === 'LY') {
      bookings = _.isNil(bookings) ? '-' : bookings;
      title = 'Curr DTD ' + dtd + '<span class="grid-title-2n-part"> Curr LY Bkgs ' + bookings + '</span>';
    } else if ($scope.modalMode === 'RY') {
      bookings = _.isNil(bookings) ? '-' : bookings;
      title = 'Curr DTD ' + dtd + '<span class="grid-title-2n-part"> Curr RY Bkgs ' + bookings + '</span>';
    }
    return {
      columngroups: [{
        text: title,
        align: 'center',
        name: 'MainGroup'
      }]
    };
  }
  function validateFn(cell, value) {
    var val = parseInt(value);
    if (cell.datafield === 'offset' && value !== '' && (isNaN(val) || val < 0 || val > 365)) {
      return {
        result: false,
        message: 'Please enter integer between 0 and 365'
      };
    }
    return true;
  }
  function fillEmpty(bookingsIntakeData) {
    var result = _.cloneDeep(bookingsIntakeData);
    var missing = MAX_ROWS - result.length;
    for (var i = 0; i < missing; i++) {
      result.push({});
    }
    return result;
  }
  function getCustomDtd() {
    var rows = $scope.gridSettings.jqxGrid('getrows');
    return _.chain(rows).map(function (item) {
      return parseInt(item.offset) + daysToDeparture;
    }).filter(function (item) {
      return !_.isNaN(item) && !_.isNil(item);
    }).sortBy(function (item) {
      return item;
    }).value();
  }
  var rmNumberFormat, source, daysToDeparture, bookingsTotal, bookingsLastYearCurrent, bookingsReferenceYearCurrent, resetData, resetChartData, rowData;
  $scope.getBookings = function (entry, lastYear, referenceYear) {
    var fieldNames = mapGridToFields($scope.sourceGridId);
    if (lastYear) {
      return entry[fieldNames.lastYear];
    }
    if (referenceYear) {
      return entry[fieldNames.referenceYear];
    }
    return entry[fieldNames.current];
  };
  $scope.updateColumns = function () {
    var cols = $scope.modalMode === 'LY' ? gridColumnsLY : $scope.modalMode === 'RY' ? gridColumnsRY : gridColumns;
    return {
      columns: _.map(cols.columns, function (col) {
        col.validation = validateFn;
        return col;
      })
    };
  };
  $scope.init = function () {
    rmNumberFormat = $filter('rmNumberFormat');
    source = {
      localdata: [],
      datafields: [{
        name: 'offset',
        type: 'string'
      }, {
        name: 'daysToDeparture',
        type: 'string'
      }, {
        name: 'thisYear',
        type: 'string'
      }, {
        name: 'intake',
        type: 'string'
      }, {
        name: 'lastYear',
        type: 'string'
      }, {
        name: 'referenceYear',
        type: 'string'
      }, {
        name: 'intakeLY',
        type: 'string'
      }, {
        name: 'intakeRY',
        type: 'string'
      }]
    };
    $scope.gridSettings = {
      width: '100%',
      height: '100%',
      altrows: true,
      editable: true,
      columns: [],
      selectionmode: 'singlecell',
      enablekeyboarddelete: false,
      source: new angular.element.jqx.dataAdapter(source),
      columngroups: [{
        text: '',
        align: 'center',
        name: 'MainGroup'
      }]
    };
  };
  $scope.init();
  $scope.xAxisLabel = 'Offset Days';
  $scope.modalMode = 'CU';
  $scope.isReferenceYearFeatureOn = function () {
    return featureToggleService.isEnabled('REFERENCE_YEAR');
  };
  $scope.modalModeList = [{
    label: 'Curr Bkgs',
    value: 'CU'
  }, {
    label: 'Curr Bkgs LY',
    value: 'LY'
  }, {
    label: 'Curr Bkgs RY',
    value: 'RY',
    hideButton: !$scope.isReferenceYearFeatureOn()
  }];
  $scope.gridId = 'market-analysis-bookings-intake';
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      return rmNumberFormat(d);
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d);
    }
  };
  $scope.gridDirty = false;
  $scope.renderGrid = function () {
    if ($scope.modalMode === 'LY') {
      $scope.gridSettings.jqxGrid(updateHeader(daysToDeparture, bookingsLastYearCurrent));
    } else if ($scope.modalMode === 'RY') {
      $scope.gridSettings.jqxGrid(updateHeader(daysToDeparture, bookingsReferenceYearCurrent));
    } else {
      $scope.gridSettings.jqxGrid(updateHeader(daysToDeparture, bookingsTotal));
    }
    $scope.gridSettings.jqxGrid($scope.updateColumns());
    $scope.gridSettings.jqxGrid('updatebounddata');
  };
  $scope.onResetClick = function () {
    $scope.closeEditing();
    source.localdata = resetData;
    $scope.gridDirty = false;
    $scope.renderChart(resetChartData);
    $scope.renderGrid();
  };
  $scope.reloadWithCustomDtd = function (customDtd) {
    dataProviderService.getData($scope.screen, $scope.sourceGridId, customDtd, rowData, bookingsTotal, bookingsLastYearCurrent, bookingsReferenceYearCurrent).then(function (data) {
      var handleData = {};
      handleData[bookingsIntakeFieldUtils.getDataFieldName()] = data;
      $scope.handleNewData(handleData, true);
    });
  };
  $scope.onApplyClick = function () {
    $scope.runValidation();
    if ($scope.isValidationMessage()) {
      return;
    }
    $scope.closeEditing();
    $scope.reloadWithCustomDtd(getCustomDtd());
  };
  $scope.handleNewData = function (row, skipResetData) {
    var bookingsIntakeData = fillEmpty(row[bookingsIntakeFieldUtils.getDataFieldName()]);
    var chartData = dataProviderService.getChartData(bookingsIntakeData);
    if (!skipResetData) {
      rowData = row;
      resetData = _.cloneDeep(bookingsIntakeData);
      resetChartData = _.cloneDeep(chartData);
      daysToDeparture = row.daysToDeparture;
      bookingsTotal = $scope.getBookings(row);
      bookingsLastYearCurrent = $scope.getBookings(row, true);
      bookingsReferenceYearCurrent = $scope.getBookings(row, false, true);
    }
    source.localdata = bookingsIntakeData;
    $scope.renderChart(chartData);
    $scope.renderGrid();
  };
  $scope.$watch('modalMode', function (newVal) {
    if (newVal && $scope.gridSettings.refresh) {
      $scope.renderGrid();
    }
  });
  $scope.onCellEdit = function () {
    $scope.gridDirty = true;
  };
  $scope.handleGridCellClick = function (rowData, gridId) {
    $scope.sourceGridId = gridId;
    $scope.gridDirty = false;
    $scope.handleNewData(rowData);
  };
};
BookingsIntakeModalController.$inject = ['$scope', '$filter', 'DataRetrieverConstantsService', 'FeatureToggleService', 'BookingsIntakeModalDataProviderService', 'BookingsIntakeModalFieldUtilService'];
module.exports = BookingsIntakeModalController;